import { useSelector } from "react-redux";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { RootState } from "@/reducers";
import { formatMoney, formatSTK } from "@/shared/utils/ultils";
import { ToastInfo } from "@/components/shared/toast/Toast";
import axios from "@/shared/config/axios-interceptor";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Recharge = () => {
  const { user } = useSelector((state: RootState) => state.authentication);
  const [setting, setSetting] = useState<any>(null);
  const getSetiing = async () => {
    try {
      const res = await axios.get("/settings/1");
      setSetting(res?.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getSetiing();
  }, []);

  const handlerCopy = async (content: string, alert: string) => {
    try {
      await navigator.clipboard.writeText(content);
      ToastInfo(`Sao chép ${alert} thành công!`);
    } catch (error) {
      ToastInfo("Lỗi sao chép");
    }
  };
  return (
    <div className="wrapper">
      <div className="container-web naptien bgnew">
        <Header title="NẠP TIỀN VÀO TÀI KHOẢN" />
        <main className="p-3">
          <div className="box-content rounded-1 p-2">
            <div className="d-flex item">
              <div className="left">Tên/User</div>
              <div className="right">{user?.username}</div>
            </div>

            <div className="d-flex item">
              <div className="left">ID</div>
              <div className="right">{user?.id}</div>
            </div>

            <div className="d-flex item">
              <div className="left">Số dư</div>
              <div className="right">{formatMoney(user?.money || 0)} VND</div>
            </div>

            <div className="d-flex item">
              <div className="left">Số tài khoản</div>
              <div className="right d-flex gap-2 align-items-center">
                {user?.cardNumber ? formatSTK(user?.cardNumber) : ""}
                {/* <i
                  onClick={() =>
                    handlerCopy(setting?.cardNumber, "Số tài khoản")
                  }
                  className="fa-solid fa-copy"
                  style={{ color: "#dea94f", cursor: "pointer" }}
                ></i> */}
              </div>
            </div>

            <div className="d-flex item">
              <div className="left">Tên ngân hàng</div>
              <div className="right d-flex gap-2 align-items-center">
                {user?.bankName}
                {/* <i
                  onClick={() =>
                    handlerCopy(setting?.bankName, "Tên ngân hàng")
                  }
                  className="fa-solid fa-copy"
                  style={{ color: "#dea94f", cursor: "pointer" }}
                ></i> */}
              </div>
            </div>

            <div className="d-flex item">
              <div className="left">Chủ tài khoản</div>
              <div className="right d-flex gap-2 align-items-center">
                {user?.cardName}
                {/* <i
                  onClick={() =>
                    handlerCopy(setting?.cardName, "Chủ tài khoản")
                  }
                  className="fa-solid fa-copy"
                  style={{ color: "#dea94f", cursor: "pointer" }}
                ></i> */}
              </div>
            </div>
            <div>
              <span className="line mb-3"></span>
            </div>
            <div>
              <p>
                Xin vui lòng liên hệ đến bộ phận chăm sóc khách hàng để gửi tiết
                kiệm vào tài khoản và giải đáp những thắc mắc của quý khách !
              </p>

              <p className="text-center">Trân trọng cảm ơn</p>

              <div>
                <Link to={"/message"} className="lien-he-cskh">
                  Liên hệ CSKH
                </Link>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Recharge;
